import DepartementPratiquesEnergetiquesTemplate from './DepartementPratiquesEnergetiquesTemplate';
import departementData from '../../data/departements/pratiques-energ/75';
export default function Departement75ParisPratiquesEnerg() {
  return <DepartementPratiquesEnergetiquesTemplate data={departementData} />;
}
